<div scrollObserver class="header">
  <mat-toolbar class="default-bg mat-elevation-z4" style="height: 78px; position: fixed; z-index: 5;">
    <img class="logo" style="height: 48px;" src="assets/images/header-logo.png">
    <div class="vertical-separator"></div>

    <div class="user-initials header-text-color">{{name + ' ' + surname}}</div>

    <div class="vertical-separator"></div>

    <div class="gradient-button-container">
      <button *ngIf="!praticaProgressService.isFrozen" mat-icon-button class="header-buttons" aria-label="Salva"
        matTooltip="Salva" (click)="save()">
        <mat-icon svgIcon="save"></mat-icon>
      </button>
      <!-- <button #historyButton mat-icon-button aria-label="History" matTooltip="History" (click)="showHistory()"
        cdkOverlayOrigin #trigger="cdkOverlayOrigin">
        <mat-icon svgIcon="history"></mat-icon>
      </button>
 -->

      <button mat-icon-button class="header-buttons" aria-label="Chiudi" matTooltip="Chiudi" (click)="saveClose()">
        <mat-icon svgIcon="exit"></mat-icon>
      </button>
    </div>
  </mat-toolbar>


  <div class="pieContainer"></div>
  <div class="pieBorder">
    <div *ngFor="let s of slices; index as i" class="buttonBorder"
      [ngClass]="{'selected-slice-border': active === s.sectionPath && (!praticaProgressService.isFrozen || praticaProgressService.isOutcome)}"
      #border [ngStyle]="{'transform': 'rotate(' + i * 60 + 'deg) skewY(-30deg)'}">
    </div>

  </div>
  <div class="pie" *ngIf="!(praticaProgressService.hasJustBeenSigned | async)">
    <button #slices *ngFor="let s of slices; index as i" sliceHover (click)="navigate(s.sectionPath)"
      [disabledSlice]="s"
      [sliceProgress]="(praticaProgressService.progress$ | async)?.[s.sectionPath] !== undefined ? (praticaProgressService.progress$ | async)?.[s.sectionPath] : 0"
      class="default-bg gradient-button-container" [targetDiv]="border?.get(i)?.nativeElement" [index]="i"
      [matTooltipPosition]="s.tooltipPosition" [matTooltip]="s.tooltip" [attr.aria-label]="s.ariaLabel"
      [ngClass]="s.class">
      <div class="text">
        <mat-icon [svgIcon]="s.icon"></mat-icon>

      </div>
    </button>

  </div>

  <button *ngIf="isReadyForSignature" mat-fab class="central-button" aria-label="Procedi alla firma pratica"
    (click)="confirm()">
    <mat-icon svgIcon="edit"></mat-icon>
  </button>

  <button *ngIf="praticaProgressService.isOutcome" mat-fab class="central-button" aria-label=""
    (click)="goToPraticaDetail()">
    <mat-icon #scorePointsIcon class="score-points-icon" svgIcon="score-points-0" [icon]="scorePointsIcon"
      [score]="score$ | async"></mat-icon>
    <div class="score-label accent">{{score$ | async}}</div>
  </button>

  <ng-lottie *ngIf="praticaProgressService.hasJustBeenSigned | async" containerClass="lottie-container" width="290px"
    height="290px" [options]="options"></ng-lottie>

  <div class="pie-bg"></div>



</div>